import React from 'react';
import { Home, GlobalLayout } from '../'

const HomePage = () => (
  <GlobalLayout>
    <Home />
  </GlobalLayout>
);

export default HomePage;